import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { locationRestConsentPost } from "../wp-api";
import { getOptionsFromWindow } from "../utils";
import { applyConsentForwarding, getCookieConsentManager } from ".";
import { commonRequest } from "@devowl-wp/utils";
/**
 * Save consent to the backend and apply cookies on running session.
 */

function applyConsent(_x) {
  return _applyConsent.apply(this, arguments);
}

function _applyConsent() {
  _applyConsent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var consent, _ref$markAsDoNotTrack, markAsDoNotTrack, buttonClicked, _ref$blocker, blocker, blockerThumbnail, tcfString, _document$documentEle, clientWidth, clientHeight, _getOptionsFromWindow, restNamespace, restRoot, restQuery, restNonce, _yield$commonRequest, forward, uuid, cookie_revision, decision_in_cookie;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            consent = _ref.consent, _ref$markAsDoNotTrack = _ref.markAsDoNotTrack, markAsDoNotTrack = _ref$markAsDoNotTrack === void 0 ? false : _ref$markAsDoNotTrack, buttonClicked = _ref.buttonClicked, _ref$blocker = _ref.blocker, blocker = _ref$blocker === void 0 ? 0 : _ref$blocker, blockerThumbnail = _ref.blockerThumbnail, tcfString = _ref.tcfString;
            _document$documentEle = document.documentElement, clientWidth = _document$documentEle.clientWidth, clientHeight = _document$documentEle.clientHeight;
            _getOptionsFromWindow = getOptionsFromWindow(), restNamespace = _getOptionsFromWindow.restNamespace, restRoot = _getOptionsFromWindow.restRoot, restQuery = _getOptionsFromWindow.restQuery, restNonce = _getOptionsFromWindow.restNonce; // Use `commonRequest` cause on frontend we do not have `wp.i18n` available

            _context.next = 5;
            return commonRequest({
              location: locationRestConsentPost,
              options: {
                restNamespace: restNamespace,
                restRoot: restRoot,
                restQuery: restQuery,
                restNonce: restNonce
              },
              sendRestNonce: false,
              request: _objectSpread(_objectSpread({}, consent), {}, {
                markAsDoNotTrack: markAsDoNotTrack,
                buttonClicked: buttonClicked,
                viewPortWidth: clientWidth,
                viewPortHeight: clientHeight,
                blocker: blocker,
                blockerThumbnail: blockerThumbnail,
                tcfString: tcfString
              }),
              params: {
                _wp_http_referer: window.location.href
              }
            });

          case 5:
            _yield$commonRequest = _context.sent;
            forward = _yield$commonRequest.forward;
            uuid = _yield$commonRequest.uuid;
            cookie_revision = _yield$commonRequest.cookie_revision;
            decision_in_cookie = _yield$commonRequest.decision_in_cookie;
            // Does the browser support cookies? Save the decision locally in `window` so `getUserDecision` can fallback
            window.rcbDisabledCookieComp = {
              uuid: uuid,
              previousUuids: [],
              revision: cookie_revision,
              consent: decision_in_cookie
            };
            _context.next = 13;
            return Promise.all([// Apply consent forwarding and wait for all requests
            forward && applyConsentForwarding(forward), getCookieConsentManager().applyCookies({
              type: "consent"
            })].filter(Boolean));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _applyConsent.apply(this, arguments);
}

export { applyConsent };